<template>
	<div :class="['chat-msg', {'msg-system': isSystem}, message.type]">
		<template v-if="message.type == 'message'">
			<div class="chat-msg-time" @click="pasteReply" @mousedown="quoteMouseDownHandler">{{ date(message.time) }}</div
			><div class="chat-msg-author" @click="pasteAuthorMention" :style="{color: message.from.color}">{{ message.from.nick }}:</div
			><message-body class="chat-msg-body" :processedBody="body"/>
		</template>

		<template v-else-if="message.type == 'message_private'">
			<span style="color: gray;">(лс)</span
			> <div class="chat-msg-time" @click="pasteReply" @mousedown="quoteMouseDownHandler">{{ date(message.time) }}</div
			><div class="chat-msg-author" @click="pasteAuthorMention" :style="{color: message.from.color}">{{ message.from.nick }}</div
				>→ <span class="chat-msg-author" @click="pasteReceiverMention" :style="{color: message.to.color}">{{ message.to.nick }}:</span
			><message-body class="chat-msg-body" :processedBody="body"/>
		</template>

		<template v-else-if="message.type == 'message_me'">
			<div class="chat-msg-time" @click="pasteReply" @mousedown="quoteMouseDownHandler">{{ date(message.time) }}</div
			><span style="color: gray;">*</span
			> <div class="chat-msg-author" @click="pasteAuthorMention" :style="{color: message.from.color}">{{ message.from.nick }}</div
			><message-body inline class="chat-msg-body" :processedBody="body"/>
		</template>

		<template v-else-if="message.type == 'message_event'">
			<div class="chat-msg-time" @click="pasteReply" @mousedown="quoteMouseDownHandler">{{ date(message.time) }}</div
			><div class="chat-msg-author" @click="pasteAuthorMention" :title="'Автор: ' + message.from.nick" :style="{color: message.from.color}">*</div
			><message-body inline class="chat-msg-body" :processedBody="body"/>
		</template>

		<template v-else-if="message.type == 'message_offtop'">
			<div class="chat-msg-time" @click="pasteReply" @mousedown="quoteMouseDownHandler">{{ date(message.time) }}</div
			><div class="chat-msg-author" @click="pasteAuthorMention" :style="{color: message.from.color}">{{ message.from.nick }}:</div
			><div class="chat-msg-body">(( <message-body inline :processedBody="body"/> ))</div>
		</template>

		<template v-else-if="message.type == 'sysmessage'">
			<div class="chat-msg-time" @click="pasteReply" @mousedown="quoteMouseDownHandler">{{ date(message.time) }}</div
			><message-body class="chat-msg-body" :processedBody="sysbody"/>
		</template>

		<template v-else-if="message.type == 'status_online'">
			<div class="chat-msg-time" @click="pasteReply" @mousedown="quoteMouseDownHandler">{{ date(message.time) }}</div
			><div class="chat-msg-body"
				><span :style="{color: syscolor2}">{{ message.user.name }}</span
				> {{ message.user.girl ? 'пришла в комнату' : 'пришел в комнату'
			}}</div>
		</template>

		<template v-else-if="message.type == 'status_offline'">
			<div class="chat-msg-time" @click="pasteReply" @mousedown="quoteMouseDownHandler">{{ date(message.time) }}</div
			><div class="chat-msg-body"
				><span :style="{color: syscolor2}">{{ message.user.name }}</span
				> {{ message.user.girl ? 'ушла из комнаты' : 'ушел из комнаты'
			}}</div>
		</template>

		<template v-else-if="message.type == 'status_change_nick'">
			<div class="chat-msg-time" @click="pasteReply" @mousedown="quoteMouseDownHandler">{{ date(message.time) }}</div
			><div class="chat-msg-body"
				><span :style="{color: syscolor2}">{{ message.user.old_name }}</span
				> {{ message.user.girl ? 'сменила ник на' : 'сменил ник на' }} <span
					:style="{color: syscolor2}">{{ message.user.name }}</span
			></div>
		</template>

		<template v-else-if="message.type == 'status_change_gender'">
			<div class="chat-msg-time" @click="pasteReply" @mousedown="quoteMouseDownHandler">{{ date(message.time) }}</div
			><div class="chat-msg-body"
				><span :style="{color: syscolor2}">{{ message.user.name }}</span
				> {{ message.user.girl ? 'сменил пол на женский' : 'сменила пол на мужской'
			}}</div>
		</template>

		<template v-else-if="message.type == 'status_change_color'">
			<div class="chat-msg-time" @click="pasteReply" @mousedown="quoteMouseDownHandler">{{ date(message.time) }}</div
			><div class="chat-msg-body"
				><template v-if="message.user.name != ''"
					><span :style="{color: syscolor2}">{{ message.user.name }}</span
					> {{ message.user.girl ? 'сменила' : 'сменил'
				}}</template
				><template v-else>Вы сменили</template
				> <span :style="{color: message.user.color}">цвет</span
			></div>
		</template>

		<template v-else>(чезанах)</template>
	</div>
</template>

<script>
import {MessageBase} from './helpers.jsx';

export default {
	mixins: [MessageBase],
}
</script>

<style lang="less" scoped>
@import (reference) "~@css/chat.less";

.chat-msg {
	.chat-msg-time {
		display: inline-block;
		color: gray;
		padding-right: 10px;
		cursor: pointer;
	}

	.chat-msg-author {
		display: inline-block;
		margin-right: 5px;
		cursor: pointer;
	}

	.chat-msg-body {
		display: inline;
		white-space: pre-wrap;
	}

	// styles

	&.msg-system {
		.chat-msg-body {
			color: @color-system-1;
		}
	}

	&.message_offtop {
		.chat-msg-body {
			color: gray;
		}
	}

	&.message_event {
		.chat-msg-author {
			border-bottom: dashed 1px;
			color: gray;
		}
	}
}
</style>
